export default "__VITE_ASSET__767fbf77__"